import { logoutUserThunk } from 'actions/userActions';
import { IUser } from 'modules/core/types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'store/selectors/auth.selector';

interface IUseConfirmTabCloseProps {
  canShow?: boolean;
}

export const useConfirmTabClose = ({ canShow = false }: IUseConfirmTabCloseProps) => {
  const user = useSelector(getUser) as IUser;
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user?.isWithInventory && canShow) {
      window.addEventListener('unload', () => {
        dispatch(logoutUserThunk());
      });
    }
  }, [canShow, user?.isWithInventory, dispatch]);
};

export default useConfirmTabClose;
